/**
 * Extract a user-facing message from a failed API call.
 * Prefers the backend's `{ error }` envelope, then the axios/Error message.
 */
export function getApiErrorMessage(err: unknown, fallback: string): string {
  if (err && typeof err === 'object') {
    const axiosError = err as {
      response?: { data?: { error?: string } };
      message?: string;
    };
    if (axiosError.response?.data?.error) {
      return axiosError.response.data.error;
    }
    if (typeof axiosError.message === 'string' && axiosError.message) {
      return axiosError.message;
    }
  }
  return fallback;
}
